<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h2>Gestione <b>Causali Movimentazioni</b></h2>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Tabelle</li>
            <li class="breadcrumb-item active">Causali movimentazioni </li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->
</div>


<div class="content-block">


  <section class="col-lg-12 ">

      <div class="card">
        <div class="card-header primary">
          <h3 class="card-title">
            <i class="fa fa-chart-pie mr-1"></i>
          </h3>
      
        </div><!-- /.card-header -->
        <div class="card-body">
            <dx-data-grid 
                [dataSource]="dataSource"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [columnHidingEnabled]="true"
                [showColumnLines]="true"
                [showRowLines]="true"
                [rowAlternationEnabled]="true"
                (onRowUpdating)="onUpdating($event)"
                [showRowLines]="true"
                (onExporting)="onExporting($event)">

                <dxo-export [enabled]="true"></dxo-export>
                <dxo-editing
                  mode="row"
                  [allowAdding]="true"
                  [allowUpdating]="true"
                  [allowDeleting] ="true"
                  [useIcons]="true"
                  >
                  <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
                </dxo-editing>

                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
                <dxi-column
                  dataField="id"
                  [formItem]="{ visible: false }"
                  [visible]="false"
                  [allowEditing]="false">
                </dxi-column>
                <dxi-column
                  dataField="codice"
                  [sortIndex]="1"
                  sortOrder="asc">
                  <dxi-validation-rule type="required" message="Inserire il codice"></dxi-validation-rule>
                </dxi-column>
                <dxi-column
                  dataField="descrizione">
                  <dxi-validation-rule type="required" message="Inserire la descrizione"></dxi-validation-rule>
                </dxi-column>
                <dxi-column
                  dataField="visibilePerMovimentazione">
                </dxi-column>
                <dxi-column
                  dataField="segno"
                  cellTemplate="iconaPiuMeno">
                  <dxo-lookup [dataSource]="srcSegno" valueExpr="value" displayExpr="desc">

                  </dxo-lookup>
                  <dxi-validation-rule type="required" message="Selezionare il segno"></dxi-validation-rule>
                </dxi-column>

                <div *dxTemplate="let item of 'iconaPiuMeno'">
                  <h3>@if (valoreVerifica(item.data.segno)) {
                    <i class="fa fa-plus-square-o"></i>
                  }
                  @if (!valoreVerifica(item.data.segno)) {
                    <i class="fa fa-minus-square-o"></i>
                  }</h3>
                </div>
        </dx-data-grid>



      </div><!-- /.card-body -->
    </div>
    <!-- /.card -->

  </section>



</div>


